export const toTitleCase = (str) => {
  return String(str)
    .replace(/([A-Z])(?=[a-z])/g, " $1")
    .replaceAll('_', ' ').toLowerCase().replace(
    /\w\S*/g,
    txt => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
  );
}
